module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="popover popover-rtl" role="tooltip">\n  <div class="arrow"></div>\n  <button type="button" class="close" data-role="end" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n  <h3 class="popover-title"></h3>\n  <div class="popover-content"></div>\n  <div class="popover-navigation popover-navigation-rtl">\n    <div class="btn-group btn-group-justified" role="group">\n      <button class="btn btn-default" data-role="prev">&laquo; הקודם</button>\n      <button class="btn btn-default" data-role="next">הבא &raquo;</button>\n      <button class="btn btn-default"\n              data-role="pause-resume"\n              data-pause-text="הקפא"\n              data-resume-text="המשך">הקפא</button>\n    </div>\n  </div>\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/tour-dialog.html
// module id = 146
// module chunks = 0